import React from 'react';
import styled from 'styled-components';
import OptionSelect, { IOption } from '../../../../../generic/ui/Selectors/OptionSelect';

type Props = {
    title: string;
    options: IOption[];
    value: IOption | null;
    onSelect: (option: IOption | null) => void;
    placeholder?: string;
    disabled?: boolean;
    leadingIcon?: React.ReactNode;
};

const LabeledOptionSelect: React.FC<Props> = ({ title, ...rest }) => (
    <MainWrapper>
        <Title>{title}</Title>
        <StyledSelect {...rest} />
    </MainWrapper>
);

const MainWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    align-items: flex-end;
    gap: 0.5em;
    padding: 0.5em 1em;
`;

const Title = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-family: ${({ theme }) => theme.fonts.sans};
    font-size: ${({ theme }) => theme.text.md};
    color: ${({ theme }) => theme.colors.ink2};
`;

const StyledSelect = styled(OptionSelect)`
    width: 20em;
    @media screen and (max-width: 500px) {
        width: 17em;
    }
`;

export default LabeledOptionSelect;
